import styles from './NavBar.module.scss';

import React, { FC } from 'react';
import { LogoLink } from 'components/LogoLink/LogoLink';
import logoImageWhite from 'images/icons/clover-logo-white.svg';

type NavBarLogoProps = {
  isTransparent?: boolean;
};

export const NavBarLogo: FC<NavBarLogoProps> = ({ isTransparent }) => {
  return (
    <div className={styles.navBarLogo}>
      <LogoLink cloverLogo={isTransparent ? logoImageWhite : undefined} />
    </div>
  );
};
